/**
 * Minicart item component
 *
 * @module minicart-item
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'minicart-item';

if (!customElements.get(customElements.component)) {

    class minicartItem extends HTMLElement {

        /**
         * Minicart item web component
         *
         * @constructor
         */
        constructor() {
            super();

            this.fbtProductURL = this.dataset.fbtProductUrl;

            window.theme.cart.getItem(this.id).then(cartItem => {
                this.render(cartItem);
            });
        }

        async checkPriceRules(cartItem) {
            try {
                const boldCustomAppUrl = 'https://api.boldcommerce.com/go_pre/pricerules/0ccab2.myshopify.com';
                const url = `${boldCustomAppUrl}/rulesets?products=${cartItem.product_id}`;
                const response = await fetch(url);
                const data = await response.json();

                if (typeof data.rulesets === 'object') {
                    this.rulesSets = data.rulesets.map(ruleset => {
                        return {
                            variantId: ruleset.product_selection.products[0].variant_id,
                            rules: ruleset.rules.filter(rule => rule.type === 'DISPLAY')
                        }
                    });

                    this.updatePriceBasedOnQuantity(cartItem);
                }
            } catch (error) {
                console.error('Error catching rulesets:', error);
            }
        }

        updatePriceBasedOnQuantity(cartItem) {
            const ruleset = this.rulesSets.find(ruleset => ruleset.variantId == cartItem.variant_id);
            const quantityBreaks = this.getQuantityBreaks(ruleset);

            const intervals = [];
            let minQty = 1;
            let currentPrice = cartItem.final_price;

            if (!quantityBreaks.length) {return false}

            quantityBreaks.forEach(element => {
                intervals.push(
                    {
                        min: minQty,
                        max: element.qty - 1,
                        price: currentPrice
                    }
                );
                currentPrice = element.price;
                minQty = element.qty;
            });
            intervals.push(
                {
                    min: minQty,
                    max: 9999999,
                    price: currentPrice
                }
            );

            this.updateDisplayPrice(cartItem, intervals);
        }

        getQuantityBreaks(ruleset) {
            const quantityBreaks = [];
            if (typeof ruleset !== 'object') {return false}

            ruleset.rules.forEach(rule => {
                rule.actions.forEach(action => {
                    if (action.type === 'DISPLAY_QTY_BREAK') {
                        quantityBreaks.push(action);
                    }
                });
            });

            return quantityBreaks;
        }

        updateDisplayPrice(cartItem, intervals) {
            intervals.forEach(interval => {
                if (this.dataset.qtyAdded >= interval.min && this.dataset.qtyAdded <= interval.max) {
                    this.querySelector('.product-final-price').innerHTML = theme.money.format(interval.price);
                    this.displayDiscountMessage((cartItem.final_price * this.dataset.qtyAdded) - (interval.price * this.dataset.qtyAdded));
                }
            });
        }

        displayDiscountMessage(discountValue) {
            const minicartContainer = this.closest('side-drawer').querySelector('[data-container]');
            const discountMessage = this.querySelector('[data-discount-message]');
            if(discountValue <= 0) {
                minicartContainer.classList.remove('!min-h-[430px]')
                discountMessage.classList.add('hidden');
                return;
            };
            minicartContainer.classList.add('!min-h-[430px]')
            discountMessage.innerHTML = `You will save ${theme.money.format(discountValue)} by buying bulk`;
            discountMessage.classList.remove('hidden');
        }

        /**
         * Render component in the DOM
         *
         * @returns {undefined}
         */
        render(cartItem) {
            let html = this.template();
            const placeholder_image =  window.theme.placeholder_image_url;

            html = html.replaceAll('{{ title }}', cartItem.product_title);
            html = html.replaceAll('{{ id }}', cartItem.id);
            html = html.replaceAll('{{ handle }}', cartItem.handle);
            html = html.replaceAll('{{ quantity }}', cartItem.quantity);
            html = html.replaceAll('{{ product_url }}', cartItem.url);
            html = html.replaceAll('{{ item_title }}', cartItem.title);

            // Variant Data
            html = html.replaceAll('{{ variant_title }}', cartItem.variant_title);
            html = html.replaceAll('{{ variant_id }}', cartItem.variant_id);
            html = html.replaceAll('{{ variant-name }}', cartItem.options_with_values[0].name);
            html = html.replaceAll('{{ variant-value }}', cartItem.options_with_values[0].value);
            html = html.replaceAll('{{ variant-value-class }}', cartItem.options_with_values[0].value.replaceAll(' ', '-').toLowerCase());

            // Loop cartItem.properties
            for (const property in cartItem.properties) {
                if (cartItem.properties.hasOwnProperty(property)) {
                    //console.log(cartItem.properties[property]);
                    html = html.replaceAll(`{{ ${property} }}`, cartItem.properties[property]);
                }
            }

            // Load Product Image
            let imageHtml = '';

            if(cartItem.featured_image.url) {
                imageHtml = `
                    <div class="w-full max-w-[112px] max-h-[112px] flex items-center justify-center p-3">
                        <img class="max-w-[88px] max-h-[88px] w-full h-auto rounded-md" src="{{ image }}" alt="{{ image_alt }}" height="{{ image_height }}" width="{{ image_width }}"></img>
                    </div>`;
            }
            else {
                imageHtml = `
                    <div class="w-full max-w-[112px] max-h-[112px] flex items-center justify-center p-3">
                        <div class="bg-neutral-100 w-full h-full flex items-center justify-center rounded-md">
                            <img class="max-w-[50px] w-full h-auto mix-blend-multiply" src="${placeholder_image}" alt="{{ image_alt }}" height="{{ image_height }}" width="{{ image_width }}"></img>
                        </div>
                    </div>`;
            }

            html = html.replace('{{ product_image }}', imageHtml);
            html = html.replace('{{ image }}', cartItem.featured_image.url ? cartItem.featured_image.url : placeholder_image);
            html = html.replace('{{ image_height }}', cartItem.featured_image.height ? cartItem.featured_image.height : "600");
            html = html.replace('{{ image_width }}', cartItem.featured_image.width ? cartItem.featured_image.width : "600");
            html = html.replace('{{ image_alt }}', cartItem.featured_image.alt ? cartItem.featured_image.alt : cartItem.title);
            html = html.replace('{{ qty_added }}', this.dataset.qtyAdded ? (this.dataset.qtyAdded + "x") : "1x");
            html = html.replaceAll('{{ final_price }}', this.dataset.qtyAdded ? window.theme.money.format(cartItem.final_price * this.dataset.qtyAdded) : window.theme.money.format(cartItem.final_price));

            this.innerHTML = html;
            this.dataset.ready =  true;

            this.checkPriceRules(cartItem);
            this.initEvents();
        }

        /**
         * Component template
         *
         * @returns {undefined}
         */
        template() {
            let viewCompatibleProductLink = '';

            if (this.fbtProductURL !== '') {
                viewCompatibleProductLink = `<a href="${this.fbtProductURL}" class="view-compatible-lid btn">View Compatible Lid</a>`;
            }

            if (window.templateMinicartItem) {

                return window.templateMinicartItem;

            } else {

                return `
                    <div class=" flex gap-3 items-center mb-3 leading-5">
                        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-check {{ class }} w-5 h-5 stroke-[#275BA9]" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                        </svg>
                        <div class=" text-base text-[#275BA9] tracking-[-0.16px;]">Item added to your cart</div>
                    </div>
                    <div class="minicart-item__content">
                        <div data-content class="flex gap-3">
                            {{ product_image }}
                            <div class="w-full text-sm relative flex flex-col gap-2">
                                <div class="text-sm leading-[18px] flex flex-col">
                                    <a href="{{ product_url }}" aria-label="{{ item_title }}" class="tracking-[-0.14px;]" style="display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2; overflow: hidden;">{{ title }}</a>
                                </div>
                                <div class="text-sm text-[#7B7778] uppercase tracking-[-0.14px;] {{ variant-value-class }}">{{ variant-name }}: {{ variant-value }}</div>
                                <div class="flex justify-between">
                                    <label for="quantity-{{ variant_id }}" class="sr-only">Quantity</label>
                                    <input id="quantity-{{ variant_id }}" class="w-2/4 max-w-[82px] pr-6 lg:pr-2 pt-3 pb-[13px] !border-n-30 text-center text-gray-30 hidden" type="number" name="quantity" data-quantity value="{{ quantity }}"></input>
                                    <div class="w-2/4 leading-5 font-bold flex flex-col text-xl">
                                        <div class="flex items-center pb-2 ">
                                            <label class="font-bold flex flex-col text-xl mb-0 qty-added">{{ qty_added }}</label>
                                            <div class=" ml-2 tracking-[-0.2px] product-final-price">{{ final_price }}</div>
                                        </div>
                                    </div>
                                </div>
                                <button class="w-4 absolute top-0 right-0" aria-label="Remove" data-remove>
                                    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-delete fill-n-10" width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19.8747 6.625V8.83333H8.83301V13.25H11.0413V41.9583C11.0413 43.1297 11.5067 44.2531 12.335 45.0814C13.1632 45.9097 14.2866 46.375 15.458 46.375H37.5413C38.7127 46.375 39.8361 45.9097 40.6644 45.0814C41.4927 44.2531 41.958 43.1297 41.958 41.9583V13.25H44.1663V8.83333H33.1247V6.625H19.8747ZM15.458 13.25H37.5413V41.9583H15.458V13.25ZM19.8747 17.6667V37.5417H24.2913V17.6667H19.8747ZM28.708 17.6667V37.5417H33.1247V17.6667H28.708Z" stroke="none"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    
                    <div class="bg-[#CDE8F4] p-2.5 text-xs text-[#114760] hidden" data-discount-message>
                        You will save by buying bulk
                    </div>
                    
                    ${viewCompatibleProductLink}
                `;
            }
        }

        /**
         * Init component events
         *
         * @returns {undefined}
         */
        initEvents() {

            this.querySelector('[data-remove]').addEventListener('click', event => {
                this.removeItem();
            });

            this.querySelector('[data-quantity]').addEventListener('change', event => {
                this.updateItem(event.target.value);
            });
        }

        /**
         * Remove item
         *
         * @returns {undefined}
         */
        removeItem() {

            return new Promise((resolve, reject) => {

                this.remove();

                window.theme.cart.remove(this.id).then(result => {
                    resolve(result);
                });
            });
        }

        /**
         * Update cart item quantity
         *
         * @returns {undefined}
         */
        updateItem(quantity) {

            return new Promise((resolve, reject) => {

                if (quantity <= 0) {

                    this.removeItem().then(resultRemove => {
                        resolve(resultRemove);
                    });

                } else {


                    window.theme.cart.update(this.id, quantity).then(result => {
                        resolve(result);
                    });
                }
            });
        }
    }

    customElements.define(customElements.component, minicartItem);
}
